import React, { useState } from 'react';
import { ThreeHero } from '../components/ThreeHero';
import { SearchBar } from '../components/SearchBar';
import { TopToolsSection } from '../components/TopToolsSection';
import { NewToolsSection } from '../components/NewToolsSection';
import { Header } from '../components/Header';
export function HomePage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const currentYear = new Date().getFullYear();
  return <div className="min-h-screen bg-black text-white selection:bg-cyan-500/30 selection:text-cyan-200 overflow-hidden font-sans" data-id="element-844">
      {/* Fixed Background Elements - Improved gradients */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-845">
        {/* Modern gradient blobs */}
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-full blur-[120px]" data-id="element-846" />
        <div className="absolute bottom-0 right-0 w-[700px] h-[700px] bg-gradient-to-tl from-purple-500/10 to-pink-500/10 rounded-full blur-[120px]" data-id="element-847" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gradient-to-r from-orange-500/5 to-yellow-500/5 rounded-full blur-[150px]" data-id="element-848" />

        {/* Subtle grid pattern */}
        <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `
              linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '100px 100px'
      }} data-id="element-849" />
      </div>

      <Header data-id="element-850" />

      <div className="relative z-10 pt-16" data-id="element-851">
        <main className="pb-32" data-id="element-852">
          <ThreeHero data-id="element-853" />

          {/* Search Bar */}
          <SearchBar data-id="element-854" />

          {/* Top Tools - Always shows 4 tools, not affected by filters */}
          <TopToolsSection data-id="element-855" />

          {/* More AI Tools - Filtered by category with inline filter */}
          <NewToolsSection activeCategory={activeCategory} setActiveCategory={setActiveCategory} data-id="element-856" />
        </main>

        <footer className="border-t border-white/10 py-12 bg-black/80 backdrop-blur-lg" data-id="element-857">
          <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-858">
            <div className="flex items-center gap-2" data-id="element-859">
              <span className="text-lg text-white font-hero" data-id="element-860">FAIND</span>
            </div>
            <div className="text-gray-500 text-sm" data-id="element-861">
              © {currentYear} Faind. All rights reserved.
            </div>
            <div className="flex gap-6 text-gray-400" data-id="element-862">
              <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-863">
                Twitter
              </a>
              <a href="#" className="hover:text-purple-400 transition-colors" data-id="element-864">
                GitHub
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>;
}